import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const DeliveryPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 bg-stone-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-green-900 mb-8">Shipping & Delivery Policy</h1>
          <div className="bg-white rounded-xl border border-stone-200 p-8 space-y-6 text-stone-700 leading-relaxed">
            <p>Nark Online provides local delivery services within Eersterust and surrounding areas.</p>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Delivery Area</h2>
              <p>We currently deliver within Eersterust and surrounding areas as specified on our platform.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Delivery Partner</h2>
              <p>Deliveries are fulfilled by the Eersterust Tuk Tuk Association.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Delivery Fee</h2>
              <p>A flat delivery fee of <strong>R30</strong> per order applies.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Delivery Timeframes</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Same day delivery</strong> for orders placed before 2pm</li>
                <li>Orders after 2pm will be delivered the following day</li>
                <li>Delivery times may vary based on availability, weather, or demand</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Order Processing</h2>
              <p>Orders are processed immediately after payment confirmation.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Missed Deliveries</h2>
              <p>If the customer is unavailable:</p>
              <ul className="list-disc pl-6 space-y-1 mt-1">
                <li>The driver may attempt to contact the customer</li>
                <li>Redelivery may incur an additional fee</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Delays</h2>
              <p>Nark Online is not liable for delays caused by:</p>
              <ul className="list-disc pl-6 space-y-1 mt-1">
                <li>Traffic or road conditions</li>
                <li>Weather</li>
                <li>Driver availability</li>
                <li>Supplier delays</li>
              </ul>
              <p className="mt-2">We will, however, communicate delays where possible.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DeliveryPolicy;
